













































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import PrintProductDetailsSection from './printProductDetailsSection.vue';
import PrintLicenseDetailsSection from './printLicenseDetalsSection.vue';
import { RootStoreState } from '@/store';
const cssPrefix = 'printproduct';
@Component({
  components: {
    ...UUIFComponent,
    PrintProductDetailsSection,
    PrintLicenseDetailsSection,
  },
})
export default class PrintProductDetails extends SwExtendedVue {
  cssPrefix = cssPrefix;
  assochint: string = '';
  selectedProduct: any = {};
  serialNumber: string = '';
  expiredServices: any = {};
  toDoList: any[] = [];
  loadingCompleted: boolean = false;
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;
  mounted() {
    this.serialNumber = this.$router.currentRoute.query.serial ? this.$router.currentRoute.query.serial.toString() : '';
    this.getProductDetails();
  }
  get getAssochint() {
    this.assochint = '';
    if (this.selectedProduct.parentAssociationList && this.selectedProduct.parentAssociationList.length > 0
      && this.selectedProduct.parentAssociationList[0].assocTypeName !== null && this.selectedProduct.parentAssociationList[0].assocTypeName !== '') {
      // tslint:disable-next-line:max-line-length
      this.assochint = this.selectedProduct.parentAssociationList[0].productID === '400' ? '' : `as ${this.selectedProduct.parentAssociationList[0].assocTypeName}`;
    }
    return this.assochint;
  }
  getProductDetails() {
    this.loadingCompleted = false;
    this.assochint = '';
    this.selectedProduct = {};
    this.expiredServices = [];
    this.toDoList = [];
    Promise.all([
      this.$store.dispatch('MswProductsStoreModule/getProductDetail', this.serialNumber),
      this.$store.dispatch('MswProductsStoreModule/getProductToDoList', this.serialNumber),
      this.$store.dispatch('MswProductsStoreModule/getServiceInfo', this.serialNumber),
    ])
    .then((res:any) => {
      if (res[0].msgCode === 'MSWAPP:SUCCESS') {
        this.selectedProduct = res[0].content.pDetail[0] ? res[0].content.pDetail[0] : {};
        if (this.selectedProduct.authCode !== undefined) {
          const parts = this.selectedProduct.authCode.match(/[\s\S]{1,4}/g) || [];
          this.selectedProduct.authCode = parts.join('-');
        } else {
          this.selectedProduct.authCode = 'N/A';
        }
      }
      if (res[1].msgCode === 'MSWAPP:SUCCESS') {
        this.toDoList = res[1].content.toDoList ? res[1].content.toDoList : [];
      }
      if (res[2].operationStatus === 'OK') {
        this.expiredServices = res[2].serviceTypeList ? res[2].serviceTypeList : [];
      }
      this.loadingCompleted = true;
      this.$store.commit('stopLoading');
    })
    .catch((error:any) => {
      this.$store.commit('stopLoading');
      console.warn(error);
    });
  }
  printPage() {
    const printer = document.getElementById('printer');
    if (printer) {
      printer.style.visibility = 'hidden';
      const page = document.getElementById('printProductDetails');
      if (page) {
        page.style.height = 'unset';
        window.print();
        printer.style.visibility = 'visible';
        page.style.height = '95vh';
      }
    }
  }
}
